// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"fullscreen_kqLv60uk","globalNav":"globalNav_AAIcAZPT","linkNoStyles":"linkNoStyles_fWwXV5by","noPadding":"noPadding_gRRTvhh8"};